var Theme;
(function (Theme) {
  Theme.getLight = function () {
    return {
      skeletonBackground: '$slate4',
      skeletonAnimation: '$slate6'
    };
  };
  Theme.getDark = function () {
    return {
      skeletonBackground: '$deepBlue3',
      skeletonAnimation: '$deepBlue4'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
